import axiosInstance from "./axiosConfig";
import { handleApiError } from "./errorHandler";

export const cuz_details = async (data) => {
    try {
        const response = await axiosInstance.post(`/api/cuz_cust_desc`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'cuz_details');
    }
};

export const priority_list = async () => {
    try {
        const response = await axiosInstance.get(`/api/qpriority_list`);
        return response;
    } catch (error) {
        throw handleApiError(error, 'priority_list');
    }
};

export const ReportingCategoryList = async (data) => {
    try {
        const response = await axiosInstance.post(`/api/ReportingCategoryList`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'ReportingCategoryList');
    }
};

export const guidance_list = async (data) => {
    try {
        const response = await axiosInstance.post(`/api/guidance_list`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'guidance_list');
    }
};

export const warining = async (data) => {
    try {
        const response = await axiosInstance.post(`/api/warn_out_of_seq`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'warining');
    }
};

export const get_qcode = async (data) => {
    try {
        const response = await axiosInstance.post(`/api/get_qcode`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'get_qcode');
    }
};
